import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, InputNumber, Row, Col } from 'antd';
import { Add_PeriodLimitation_Api } from '../../API/PeriodLimitationApi'; // فرض شده است
import { AllCategoryComponent } from '../Category/AllCategoryComponent'; // فرض شده است
import { RollbackOutlined, CheckOutlined } from '@ant-design/icons';

// وارد کردن DatePicker و تنظیمات شمسی (همانند EditPeriodComponent)
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa"; 


// =================================================================
// فرمت مورد نظر سرور برای تاریخ شمسی با خط تیره و ارقام انگلیسی
const SERVER_DATE_FORMAT = "YYYY-MM-DD"; 

/**
 * تابع کمکی برای تبدیل ارقام فارسی (و عربی) در یک رشته به ارقام انگلیسی/لاتین،
 * حذف فضاهای خالی و تبدیل اسلش به خط تیره برای سازگاری با فرمت سرور (YYYY-MM-DD).
 * @param {string} str - رشته‌ای شامل ارقام فارسی/عربی.
 * @returns {string} - رشته‌ای با ارقام انگلیسی و فرمت YYYY-MM-DD.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    
    let output = String(str).trim(); 

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    // تبدیل اسلش به خط تیره برای فرمت YYYY-MM-DD
    return output.replace(/\//g, "-"); 
};

// =================================================================
// کامپوننت آداپتور برای اتصال DatePicker به Form.Item آنت‌دیزاین
const PersianDatePickerAdapter = ({ value, onChange }) => {
    const [dateValue, setDateValue] = useState(null);

    // تبدیل مقدار رشته‌ای (با فرمت سرور) به DateObject برای نمایش در تقویم
    const toDateObject = (dateString) => {
        if (!dateString) return null;
        // در اینجا، حتی اگر تاریخ از سرور با اسلش آمده باشد، PersianToEnglish آن را به خط تیره تبدیل می‌کند
        const englishDateString = persianToEnglishNumbers(dateString); 
        
        return new DateObject({
            calendar: persian,
            locale: persian_fa,
            date: englishDateString,
            format: SERVER_DATE_FORMAT 
        });
    };
    
    // اثر جانبی: به‌روزرسانی State داخلی DatePicker
    useEffect(() => {
        setDateValue(toDateObject(value));
    }, [value]);

    // هندل کردن تغییرات کاربر در تقویم
    const handleOnChange = (dateObject) => {
        setDateValue(dateObject); 

        let dateString = null;
        if (dateObject) {
            // خروجی گرفتن از DateObject با فرمت مورد نیاز سرور (YYYY-MM-DD) با ارقام فارسی (فعلا)
            const persianDateString = Array.isArray(dateObject) ? 
                         dateObject.map(d => d.format(SERVER_DATE_FORMAT)) : 
                         dateObject.format(SERVER_DATE_FORMAT);

            // تبدیل ارقام فارسی به انگلیسی در لحظه خروج برای ارسال به State خارجی
            dateString = persianToEnglishNumbers(persianDateString);
        }
        
        // ارسال مقدار رشته‌ای تمیز و انگلیسی (با خط تیره) به Form.Item
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={dateValue}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input" 
            calendarPosition="bottom-right"
            // فرمت نمایش در کادر ورودی
            format={SERVER_DATE_FORMAT} 
        />
    );
};

// =================================================================
export const AddPeriodLimitationComponent = ({ periodId, setLoading, showMessage, rowInserted, cancelInsert }) => {
    // =================================================================
    const [form] = Form.useForm();
    // این State ها مستقیماً تاریخ را با فرمت نهایی (YYYY-MM-DD انگلیسی) دریافت می‌کنند
    const [fromDate, setFromDate] = useState(null); 
    const [toDate, setToDate] = useState(null);
    const [categoryId, setCategoryId] = useState(-1);
    // =================================================================
    
    useEffect(() => {
        form.setFieldsValue({ isActive: true });
    }, []);
    // =================================================================
    
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            // مقادیر fromDate و toDate از آداپتور دریافت شده‌اند و قبلاً تبدیل نهایی به فرمت سرور انجام شده است.
            const updatedValues = {
                ...values,
                id: 0,
                periodId: periodId,
                // استفاده مستقیم از State که توسط PersianDatePickerAdapter تنظیم شده است
                from_Shamsi: fromDate, 
                to_Shamsi: toDate,     
                categoryId: categoryId,
            };
            
            console.log("Values Sent to API:", updatedValues);
            
            let data = await Add_PeriodLimitation_Api(updatedValues);
            setLoading(false);
            
            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful")
                rowInserted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // =================================================================
    
    return (
        <>
            <div className='sectionTitle'>
                <h2 >
                    ایجاد محدودیت جدید
                </h2>
            </div>

            <div className='container'>
                <Form
                    name="basic"
                    form={form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    onFinish={onSubmit}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        name="title"
                        label="عنوان"
                        rules={[{ required: true, message: 'لطفاً عنوان را وارد کنید!' }]}
                    >
                        <Input placeholder='عنوان' />
                    </Form.Item>

                    <Form.Item
                        name="comment"
                        label="شرح"
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='شرح' />
                    </Form.Item>

                    {/* استفاده از PersianDatePickerAdapter جدید */}
                    <Form.Item
                        name="from_Shamsi" 
                        label="از تاریخ"
                        rules={[{ required: true, message: 'لطفاً تاریخ شروع را انتخاب کنید!' }]}
                    >
                        <PersianDatePickerAdapter value={fromDate} onChange={setFromDate} />
                    </Form.Item>

                    <Form.Item
                        name="to_Shamsi"
                        label="تا تاریخ"
                        rules={[{ required: true, message: 'لطفاً تاریخ پایان را انتخاب کنید!' }]}
                    >
                        <PersianDatePickerAdapter value={toDate} onChange={setToDate} />
                    </Form.Item>

                    <Form.Item
                        name="categorySelection"
                        label="محدودیت برای گروه"
                        // این فیلد برای نمایش است، مقدار categoryId مستقیماً از State استفاده می‌شود
                    >
                        {/* کامپوننت AllCategoryComponent */}
                        <AllCategoryComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            parentId={-1}
                            isShowAddSubCategory={false}
                            isShowEdit={false}
                            isShowDelete={false}
                            isLoadObjectInstanceCategories={false}
                            isLoadCategoryFromParam={true}
                            selectedCategory={categoryId}
                            isShowCheckBox={true}
                            onCheckChange={(catId, checked) => { if (checked) setCategoryId(catId); }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="isForAll"
                        label="محدودیت همراهان"
                        valuePropName='checked'
                    >
                        <Checkbox > </Checkbox>
                    </Form.Item>

                    <Form.Item
                        name="orderIndex"
                        label="ترتیب"
                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        name="isActive"
                        label="فعال"
                        valuePropName='checked'
                    >
                        <Checkbox ></Checkbox>
                    </Form.Item>
                </Form>
            </div>

            <Row className='sectionFooter'>
                <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        style={{ width: '98%' }}
                        className='btn-primary'
                        htmlType="submit"
                        onClick={() => form.submit()}>
                        <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        className='btn-secondary'
                        style={{ width: '100%' }}
                        onClick={() => cancelInsert()}>
                        <RollbackOutlined />
                        لغو </Button>
                </Col>
            </Row>
        </>
    )
}